import React, { useState } from 'react';
import { 
    Box, 
    RadioGroup,
    Stack,
    Radio,
    Text,
    Divider,
    Flex, 
    Checkbox
} from '@chakra-ui/react';
import CustomButton from '../../components/ui/buttons/Button';
import { EmailNotificationsOptions, emailUpdates, SignInNotificationsOptions } from '../../utilities/dummy';
import { EmailUpdatesData } from '../../types/page';

export default function Notifications() {
    const [emailNotificationType, setEmailNotificationType] = useState<string>('');
    const [signInNotificationType, setSignInNotificationType] = useState<string>('');
    const [checkedEmailUpdates, setCheckedEmailUpdates] = useState<EmailUpdatesData>({
        "webinars": true,
        "tips_tricks": false,
        "offers_promotions": true,
        "marketing_newsletters": false
    })

    function handleEmailNotificationChange(val:string) {
        setEmailNotificationType(val)
    }

    function handleSignInNotificationChange(val:string) {
        setSignInNotificationType(val)
    }

    function isBtnDisabled() {
        return !emailNotificationType || !signInNotificationType
    }

    function handleEmailUpdateChange(key: string, val: boolean) {
        setCheckedEmailUpdates((prevState) => ({
            ...prevState,
            [key]: val
        }))
    }
    
    return (
        <Box paddingX={'6'} paddingLeft='8' paddingBottom='6'>
            <Box marginTop='4' marginBottom='4'>
                <Box paddingTop='0' marginBottom='6'>
                    <Text fontSize='md' color='gray.700' fontWeight={'semibold'}>
                        Email Notifications
                    </Text>
                    <Text marginTop={'1'} fontSize={'sm'} color='gray.500'>
                        Get email notifications from Elem-Pro for every direct message, mention, or announcement made whether you're online or not.
                    </Text>
                </Box>
                <Divider />

               <Box paddingTop='0' marginTop='4' maxW={'lg'}>
                    <Text fontSize='md' color='gray.700' fontWeight={'semibold'}>
                        Send me email notifications:
                    </Text>
                    <RadioGroup 
                        defaultValue={EmailNotificationsOptions[0]?.key} 
                        onChange={handleEmailNotificationChange}
                        marginTop='4'
                    >
                        <Stack>
                            {EmailNotificationsOptions.map((option) => (
                                <Radio value={option.key} size='md'>
                                   {option.desc}
                                </Radio>
                            ))}
                        </Stack>
                    </RadioGroup>
                </Box>
            </Box>

            <Divider />

            {/* Sign in notifications */}
            <Box marginTop='8' marginBottom='8'>
                <Box paddingTop='0' marginBottom='6'>
                    <Text fontSize='md' color='gray.700' fontWeight={'semibold'}>
                        Sign-In Notifications
                    </Text>
                    <Text marginTop={'1'} fontSize={'sm'} color='gray.500'>
                        Get sign-in notifications from Elem-Pro for every time you sign in to your account.
                    </Text>
                </Box>

               <Box paddingTop='0' marginTop='6' maxW={'lg'}>
                    <RadioGroup 
                        defaultValue={SignInNotificationsOptions[2].key} 
                        onChange={handleSignInNotificationChange}
                        marginTop='4'
                    >
                        <Stack>
                            {SignInNotificationsOptions.map((option) => (
                                <Radio value={option.key} size='md' marginBottom={'2'}>
                                    <Text fontSize='md' color='gray.700' textTransform={'capitalize'} fontWeight={'semibold'}>
                                        {option.key}
                                    </Text>
                                    <Text fontSize={'md'} color='gray.500'>
                                        {option.desc}
                                    </Text>
                                </Radio>
                            ))}
                        </Stack>
                    </RadioGroup>
                </Box>
            </Box>

            <Divider />
            {/* emails news and updates */}
            <Box marginTop='8' marginBottom='8'>
                <Box paddingTop='0' marginBottom='6'>
                    <Text fontSize='md' color='gray.700' fontWeight={'semibold'}>
                        Email News & Updates
                    </Text>
                    <Text marginTop={'1'} fontSize={'sm'} color='gray.500'>
                        Elem-Pro will like to occasionally send you emails with news and updates about our services. Choose which update you'll like to receive from us
                    </Text>
                </Box>

               <Box paddingTop='0' marginTop='6' maxW={'lg'}>
                    <Stack spacing={3} direction='column'>
                        {emailUpdates.map((update) => (
                            <Checkbox 
                                colorScheme='blue' 
                                value={update.key} 
                                isChecked={checkedEmailUpdates[update.key]} 
                                onChange={(e) => handleEmailUpdateChange(update.key, e.target.checked)}
                            >
                                {update.title}
                            </Checkbox>
                        ))}
                    </Stack>
                </Box>
            </Box>

            <Divider />
            {/* Button */}
            <Flex marginTop='8' justifyContent={'flex-end'} alignItems='center'>
                <CustomButton
                    className="ml--10"
                    label='Save changes'
                    variant='solid'
                    isDisabled={isBtnDisabled()}
                    cta={'primary'}
                    size={'sm'}
                />  
            </Flex>
        </Box>  
    )
}